import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import {Grid, Container} from '@material-ui/core';

import MySwiper from 'components/Shared/MySwiper';
import CinemaCard from 'components/CinemaCard';
import Context from 'utils/Context';
import Conf from 'utils/Conf';

import FilmCard from './FilmCard';

const parseMovie = film => ({
  ...film,
  film_id: film.id,
  teaser_id: film.teaser_id,
  infos_synopsis: film.synopsis,
  infos_sticker: film.sticker,
  infos_casting: film.casting,
  infos_note: film.note,
  infos_genre: film.genre,
  infos_presse: film.press,
  infos_producteur: film.producer,
  infos_realisateur: film.director,
  infos_duree: film.duration,
  infos_date_sortie: film.release_date,
  infos_annee_prod: film.production_date,
  infos_recompenses: film.rewards,
  affiche: film.affiche,
  distributeur_name: film.distributeur,
  nb_seances: null,
  local: null,
});

const getItemsNBPerSlide = screenSize => {
  switch (screenSize) {
    case 'xs':
    case 'sm':
      return 3;
    case 'md':
      return 4;
    case 'xl':
      return 6;
    default:
      return 5;
  }
};

const CinemaSliderVodItem = ({cinema}) => {
  const [vods, setVods] = useState([]);
  const {appState, goTo, methods} = useContext(Context);

  useEffect(() => {
    axios.get(`${Conf.apiBaseUri}/cinemas/${cinema.cinema_id}/vod`, {withCredentials: false}).then(res => {
      if (!res.data) return;

      setVods(res.data);
    });

    return () => {
      setVods([]);
    };
  }, [cinema.cinema_id]);

  const nb = getItemsNBPerSlide(appState.screenSize);
  const ratio = appState.screenSize === 'xs' ? 2.5 : 1;

  const sliderParams = {
    speed: 800,
    spaceBetween: 30,
    slidesPerView: nb,
    slidesPerGroup: nb,
    navigation: true,
    longSwipesRatio: 0.2,
    on: {init: methods.tick},
  };

  if (!vods.length) return null;

  return (
    <Grid container justifyContent="center" key={`cinema-${cinema.cinema_id}`} className="cinema-slider__infos">
      <Grid item xs={12} sm={4} md={3}>
        <Grid container>
          <Grid item xs={12} sm={11} className="cinema-slider__infos-left">
            <CinemaCard cinema={cinema} goTo={goTo} ratio={ratio} />
            <div className="spacer" />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={8} md={9} className="cinema-slider__infos-right">
        <Container maxWidth="xl">
          <MySwiper
            list={vods.map(vod => (
              <FilmCard
                film={parseMovie(vod.film)}
                onClick={() => goTo(`/cinema/${cinema.cinema_id}/${vod.film.id}`)}
              />
            ))}
            params={sliderParams}
          />
        </Container>
      </Grid>
    </Grid>
  );
};

export default CinemaSliderVodItem;
